var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 13.3335C14.0697 13.3335 14.6667 13.9304 14.6667 14.6668V21.3335C14.6667 22.0699 14.0697 22.6668 13.3333 22.6668C12.597 22.6668 12 22.0699 12 21.3335V14.6668C12 13.9304 12.597 13.3335 13.3333 13.3335Z",
    fill: "#F15B59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6693 13.3335C19.4057 13.3335 20.0026 13.9304 20.0026 14.6668V21.3335C20.0026 22.0699 19.4057 22.6668 18.6693 22.6668C17.9329 22.6668 17.3359 22.0699 17.3359 21.3335V14.6668C17.3359 13.9304 17.9329 13.3335 18.6693 13.3335Z",
    fill: "#F15B59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3307 2.6665C11.1216 2.6665 9.33073 4.45736 9.33073 6.6665H5.33073H3.9974C3.26102 6.6665 2.66406 7.26346 2.66406 7.99984C2.66406 8.73622 3.26102 9.33317 3.9974 9.33317H5.33073V25.3332C5.33073 27.5423 7.12159 29.3332 9.33073 29.3332H22.6641C24.8732 29.3332 26.6641 27.5423 26.6641 25.3332V9.33317H27.9974C28.7338 9.33317 29.3307 8.73622 29.3307 7.99984C29.3307 7.26346 28.7338 6.6665 27.9974 6.6665H26.6641H22.6641C22.6641 4.45737 20.8732 2.6665 18.6641 2.6665H13.3307ZM19.9974 6.6665C19.9974 5.93012 19.4004 5.33317 18.6641 5.33317H13.3307C12.5943 5.33317 11.9974 5.93012 11.9974 6.6665H19.9974ZM9.33073 9.33317H7.9974V25.3332C7.9974 26.0695 8.59435 26.6665 9.33073 26.6665H22.6641C23.4004 26.6665 23.9974 26.0695 23.9974 25.3332V9.33317H22.6641H9.33073Z",
    fill: "#F15B59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trashIcon.19cb234a8ce809fdd994ecc9b2cdf77b.svg";
export { ForwardRef as ReactComponent };